import React from "react";

import { LabeledField, SectionCard, Select } from "shared/ui";

import { useIikoIntegrationContext } from "features/IikoIntegration/context";

/*
* Второй шаг мастера. Организация сохраняется сразу при выборе: выбор один, откладывать его
* до кнопки нечего — поэтому вместо кнопки подпись о том, что уже сохранено.
* */
export const OrganizationStep = () => {
    const state = useIikoIntegrationContext();

    const saving = state.saving.organization;

    return (
        <SectionCard>
            <LabeledField
                label="Организация"
                htmlFor="iiko-organization"
                hint={saving ? "Сохраняем…" : "Сохранено автоматически"}
            >
                <Select
                    id="iiko-organization"
                    value={state.organizationId ?? ""}
                    options={state.organizationOptions}
                    disabled={saving}
                    onChange={state.selectOrganization}
                />
            </LabeledField>
        </SectionCard>
    );
};
